import React from 'react';
import ReactECharts from 'components/ThemedECharts';

import {
  DARK_BLUE, MEDIUM_BLUE, BLUE, LIGHT_BLUE, GREEN, EXTRA_STATE,
} from 'constants/colors';
import { DecompVisaoGeral } from 'types/Relatorios/Decomp';

const PALETA = [DARK_BLUE, MEDIUM_BLUE, BLUE, LIGHT_BLUE, GREEN, EXTRA_STATE]; // tema: cor de dado

interface Props { data: DecompVisaoGeral; }

export default function VisaoGeralChart({ data }: Props) {
  const option = {
    legend: { data: data.series.map((s) => s.nome) },
    xAxis: { type: 'category', data: data.periodos },
    yAxis: { type: 'value', name: data.unidade },
    series: data.series.map((s, i) => ({
      name: s.nome,
      type: 'line',
      data: s.valores,
      color: PALETA[i % PALETA.length],
      ...(i < 2 ? { areaStyle: { opacity: 0.15 } } : {}),
    })),
    tooltip: { trigger: 'axis' },
    grid: { left: '10%', right: '5%', containLabel: true },
  };

  return <ReactECharts option={option} style={{ height: 320 }} />;
}
